import { Subject, combineLatest, Observable, from, switchMap } from 'rxjs';
import {
  Component,
  Inject,
  OnInit,
  Output,
  EventEmitter,
  AfterContentInit,
  OnDestroy,
  Input,
  inject,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import {
  Router,
  NavigationEnd,
  NavigationStart,
  RouterLink,
} from '@angular/router';
import * as _ from 'lodash-es';
import { MediaObserver } from '@angular/flex-layout';
import {
  ModalService,
  FilterService,
  LocationService,
  ProfilesService,
  UserService,
  NotificationService,
} from '@app/shared/services';
import { AccountMenuService, AccountService } from '@app/account/services';
import {
  L10N_CONFIG,
  L10N_LOCALE,
  L10nConfig,
  L10nLocale,
  L10nTranslationService,
  L10nTranslatePipe,
} from 'angular-l10n';
import { ConfigService } from '@app/shared/services/config.service';
import { select, Store } from '@ngrx/store';
import { getLanguageList } from '@app/shared/reducers/shared.selectors';
import {
  debounceTime,
  distinctUntilKeyChanged,
  filter,
  map,
  takeUntil,
  withLatestFrom,
} from 'rxjs/operators';
import { getCurrentUserAction } from '@app/shared/actions/shared.actions';
import {
  getCurrentUser,
  getCurrentUserPreference,
  getUnViewedNotifications,
} from '@app/shared/reducers/user.selectors';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AccountMenuComponent } from '../account-menu/account-menu.component';
import { SvgIconComponent } from 'angular-svg-icon';
import {
  AsyncPipe,
  NgForOf,
  NgIf,
  NgSwitch,
  NgSwitchCase,
  NgTemplateOutlet,
} from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import {
  CurrentUser,
  ProfileApprovedStatus,
} from '@app/shared/models/current-user';
import { FilterV2Service } from '@app/shared/services/filter-v2.service';
import { StaticUtilsService } from '@app/shared/services/static-utils.service';
import {
  APP_CONFIG,
  FeatureFlags,
  LanguageList,
} from '@app/shared/models/constants';
import { openInstaMap } from '@app/instafeature/store/instafeature.actions';
import { InstafeatureFilterService } from '@app/instafeature/services/instafeature-filter.service';
import {
  ChatClientService,
  DefaultStreamChatGenerics,
} from 'stream-chat-angular';
import { StreamChatService } from '@app/shared/services/stream-chat.service';
import { StreamChat } from 'stream-chat';
import { _t } from '@app/shared/helpers';
import { ToastType } from '@app/shared/models/toast.model';

@Component({
  selector: 'gingr-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    MatToolbarModule,
    FlexModule,
    ExtendedModule,
    NgIf,
    RouterLink,
    SvgIconComponent,
    NgTemplateOutlet,
    AccountMenuComponent,
    MatIconModule,
    MatButtonModule,
    L10nTranslatePipe,
    MatMenuModule,
    NgForOf,
    AsyncPipe,
    NgSwitch,
    NgSwitchCase,
  ],
})
export class HeaderComponent implements OnInit, AfterContentInit, OnDestroy {
  private readonly instafeatureFilterService = inject(
    InstafeatureFilterService
  );
  private audio = new Audio();
  private chatClient: StreamChat<DefaultStreamChatGenerics> | undefined;

  @Output() navToggle = new EventEmitter<boolean>();
  @Output() filterToggle = new EventEmitter<boolean>();
  @Output() themeToggle: EventEmitter<any> = new EventEmitter<any>();
  @Output() light: EventEmitter<any> = new EventEmitter();
  @Output() dark: EventEmitter<any> = new EventEmitter();

  @Output() openNav: EventEmitter<any> = new EventEmitter();
  @Output() closeNav: EventEmitter<any> = new EventEmitter();
  @Input() isMenuClosed: boolean = false;

  public currentUser: CurrentUser;
  public isMobile: boolean;
  public isPreICO = this.configService.config.isPreICO === 'true';

  routerState: string;
  isAuthenticated: boolean = false;
  isMenuOpen: boolean;
  showLogo: boolean = false;
  isProUser: boolean = false;

  showFilterIcon: boolean = true;
  showMapIcon: boolean = true;
  showGridIcon: boolean = true;
  isInsta = true;
  filtersSelectedMainGrid$: Observable<number>;
  filtersSelectedInsta$: Observable<number>;
  hideFindClients = true;

  roleLink: string;

  prefLangKey = 'prefLang';
  fullLanguageName: string = 'English';

  // userLocation: UserLocation;
  languages = LanguageList;

  changeLanguage: boolean;
  languageList: any[];
  playChatSoundAtNextInteraction = false;

  elementSettings = {
    location: {
      width: 20,
      show: false,
    },
    accountMenu: {
      width: 40,
      show: false,
    },
    createFreeProfileButton: {
      show: true,
    },
    pressLoginButton: {
      show: false,
    },
    pressLogoutButton: {
      show: false,
    },
  };

  unViewedNotifications: number;

  'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.8.0/flags/1x1/';
  public navigationText: string;

  public schema = this.l10nConfig.schema;

  private destroy$ = new Subject<boolean>();

  apiKey: string = null;
  public unreadChatMessages: number;
  private readonly config = inject(APP_CONFIG);
  readonly streamChatService = inject(StreamChatService);
  readonly chatService = inject(ChatClientService);
  readonly translate = inject(L10nTranslationService);
  readonly notifyService = inject(NotificationService);
  private afterInitialiseChat = new Subject<boolean>();
  constructor(
    private router: Router,
    private store: Store<any>,
    private accountService: AccountService,
    private observableMedia: MediaObserver,
    private modalService: ModalService,
    private geolocation: LocationService,
    private configService: ConfigService,
    private menuService: AccountMenuService,
    @Inject(L10N_CONFIG) public l10nConfig: L10nConfig,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private translationService: L10nTranslationService,
    public userService: UserService,
    public filterService: FilterService,
    public profilesService: ProfilesService,
    private filterV2Service: FilterV2Service
  ) {
    this.apiKey = this.config.streamchat.apiKey;
    this.audio.src = '/assets/audio/new-chat-message.mp3';
    this.audio.load();
  }

  @HostListener('document:click', ['$event'])
  documentClick() {
    if (this.playChatSoundAtNextInteraction) {
      this.playChatSoundAtNextInteraction = false;
      this.audio.play().catch((error) => {
        console.error('Audio playback backup failed', error);
      });
    }
  }

  navOpen() {
    this.navToggle.emit(true);
    this.isMenuOpen = !this.isMenuOpen;
  }
  filterOpen() {
    this.filterToggle.emit(true);
  }

  ngAfterContentInit() {
    combineLatest([
      this.menuService.accountHeader,
      this.observableMedia.asObservable(),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([headerText, change]) => {
        this.navigationText = headerText;
        this.isMobile = change[0].mqAlias === 'xs';
        switch (change[0].mqAlias) {
          case 'xs':
            this.closeNav.emit();
            this.isMenuOpen = false;
            !this.navigationText
              ? this.setShowLogo(true)
              : this.setShowLogo(false);
            break;
          case 'sm':
          case 'md':
            this.closeNav.emit();
            this.isMenuOpen = false;
            this.setShowLogo(true);
            break;
          case 'lg':
            this.openNav.emit();
            this.isMenuOpen = true;
            this.setShowLogo(true);
            break;
          case 'xl':
            this.openNav.emit();
            this.isMenuOpen = true;
            this.setShowLogo(true);
            break;
        }
      });
  }

  async ngOnInit() {
    this.filtersSelectedMainGrid$ =
      this.filterV2Service.filtersSelected.asObservable();
    this.filtersSelectedInsta$ =
      this.instafeatureFilterService.filtersSelected.asObservable();

    this.changeLanguage = StaticUtilsService.LdClient.variation(
      FeatureFlags.ChangeLanguage,
      false
    );

    this.store
      .pipe(select(getLanguageList), takeUntil(this.destroy$))
      .subscribe((data) => (this.languageList = data));

    this.store
      .pipe(select(getUnViewedNotifications), takeUntil(this.destroy$))
      .subscribe((data) => (this.unViewedNotifications = data));

    this.checkRoute();
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      if (e instanceof NavigationEnd || e instanceof NavigationStart) {
        this.checkRoute();
      }
    });

    // check if user is pro
    this.userService.isProUser.pipe(takeUntil(this.destroy$)).subscribe(
      (userProStatus) => {
        setTimeout(() => {
          this.isProUser = userProStatus;
        }, 100);
      },
      (errors) => {
        this.isProUser = false;
      }
    );

    this.store
      .pipe(
        select(getCurrentUser),
        filter((user) => user !== undefined),
        distinctUntilKeyChanged('id'),
        takeUntil(this.destroy$)
      )
      .subscribe((user) => {
        this.isAuthenticated = !!user;

        if (user) {
          this.elementSettings.location.width = 20;
          this.elementSettings.accountMenu.show = true;

          localStorage.removeItem(this.prefLangKey);
          this.currentUser = _.cloneDeep(user);
          this.setLang(this.currentUser.langIso);
          this.initChat(this.currentUser.id);
        } else {
          this.currentUser = null;
          const prefLang = localStorage.getItem(this.prefLangKey);
          if (prefLang) {
            setTimeout(() => {
              this.setLang(prefLang);
            }, 100);
          }
          this.elementSettings.location.width = 60;
          this.elementSettings.accountMenu.show = false;
        }

        this.checkElementsSettings();
      });

    this.afterInitialiseChat
      .pipe(
        switchMap(() => this.chatService.events$),
        takeUntil(this.destroy$),
        filter(
          (event) =>
            (event.eventType === 'notification.message_new' ||
              event.eventType === 'notification.mark_read' ||
              ((event.eventType === 'message.new' ||
                event.eventType === 'message.read') &&
                +event.event.user.id !== this.currentUser.id)) &&
            event.event.total_unread_count !== undefined
        )
      )
      .subscribe((eventRes: any) => {
        this.unreadChatMessages = eventRes.event.total_unread_count;
      });

    this.afterInitialiseChat
      .pipe(
        takeUntil(this.destroy$),
        switchMap(() => this.chatService.events$),
        withLatestFrom(this.store.select(getCurrentUserPreference)),
        filter(
          ([event, userPreferences]) => userPreferences?.notificationsSoundOn
        ),
        map(([event, userPreferences]) => event),
        filter(
          (event) =>
            (event.eventType === 'notification.message_new' &&
              +event.event.message.user.id !== this.currentUser.id) ||
            (event.eventType === 'message.new' &&
              +event.event.user.id !== this.currentUser.id)
        ),
        debounceTime(1000)
      )
      .subscribe((eventRes: any) => {
        this.playNotificationSound(eventRes.event.user);
      });

    await StaticUtilsService.LdClient.waitUntilReady().then();
    this.hideFindClients = StaticUtilsService.LdClient.variation(
      FeatureFlags.HideFindClients,
      true
    );
  }

  redirectToMainPage() {
    if (this.router.url.includes('/instafeature')) {
      return;
    }

    this.router.navigate(['/gingrs']);
  }

  checkRoute() {
    if (this.isMobile && this.isMenuOpen) {
      this.closeNav.emit();
      this.isMenuOpen = false;
    }
    this.routerState = this.router.url;

    this.showMapIcon =
      this.routerState &&
      (this.routerState === '/gingrs' ||
        this.routerState === '/gingrs/profile' ||
        this.routerState === '/agencies' ||
        this.routerState === '/establishments' ||
        this.routerState.includes('/instafeature/find-gingr'));

    this.showFilterIcon =
      this.routerState &&
      (this.routerState === '/gingrs' ||
        this.routerState === '/agencies' ||
        this.routerState === '/establishments' ||
        this.routerState.includes('/instafeature/find-gingr'));

    this.showGridIcon =
      this.routerState &&
      this.routerState.indexOf('map') !== -1 &&
      this.routerState.indexOf('profile') === -1;

    this.isInsta = this.routerState.includes('/instafeature');

    this.checkElementsSettings();
  }

  public ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  public checkIsOnState(url: string): boolean {
    return this.routerState.indexOf(url) !== -1;
  }

  /**
   * check location and account menu blocks settings
   */
  checkElementsSettings(): void {
    this.elementSettings.location.show =
      (this.routerState && this.routerState.indexOf('map') !== -1) ||
      this.routerState === '/gingrs' ||
      this.routerState === '/establishments' ||
      this.routerState === '/agencies';
    this.elementSettings.createFreeProfileButton.show = true;
    this.elementSettings.pressLoginButton.show = false;

    if (this.routerState && this.routerState.indexOf('account') > 0) {
      this.elementSettings.accountMenu.show = true;
    } else {
      this.elementSettings.accountMenu.show = false;
    }

    if (this.elementSettings.accountMenu.show) {
      this.elementSettings.location.width = 20;
    } else {
      this.elementSettings.location.width = 60;
    }
  }

  selectLocale(language: string, fullLanguage: string): void {
    if (this.currentUser) {
      const languageModel = _.find(this.languageList, {
        languages_name: language,
      });
      if (languageModel) {
        this.currentUser.language = languageModel.id;
        this.currentUser.langIso = languageModel.languages_name;

        this.accountService
          .updateAccountLanguage(this.currentUser.language)
          .subscribe(() => this.store.dispatch(getCurrentUserAction()));
      }
    } else {
      localStorage.setItem(this.prefLangKey, language);
    }
    this.setLang(language);
  }

  setLang(lang: string) {
    const item = this.schema.find((e) => e.locale.language === lang);
    const selectedItem = this.languages.find((el) => el.value === lang);
    this.fullLanguageName = selectedItem.viewValue;
    if (item) {
      this.translationService.setLocale(item.locale);
    }
  }

  mapLang(lang): string {
    if (lang === 'en') {
      return 'gb';
    }
    return lang;
  }

  public backToGrid() {
    this.router.navigate([this.filterV2Service.currentRole]);
    this.profilesService.pushProfiles([]);
  }

  public goToMap() {
    if (!this.showMapIcon) {
      return;
    }
    if (this.isInsta) {
      this.store.dispatch(openInstaMap());
      return;
    }
    this.router.navigate([this.filterV2Service.currentRole, 'map']);
  }

  locationChanged(location) {
    this.geolocation.setUserPosition(location);
  }

  private setShowLogo(value: boolean) {
    setTimeout(() => (this.showLogo = value), 100);
  }

  openInstantBookingPromo() {
    if (this.hideFindClients) {
      return;
    }
    if (
      this.currentUser?.profileApprovedStatus !==
        ProfileApprovedStatus.APPROVED &&
      this.router.url.includes('account/profile')
    ) {
      this.notifyService.addToast({
        message: this.translate.translate(
          _t('ACCOUNT.Your profile needs to be approved to find clients')
        ),
        timeout: 3000,
        type: ToastType.Warning,
      });
      return;
    }
    this.userService.openInstantBooking();
  }

  initChat(userId: number) {
    this.streamChatService
      .getStreamChatToken()
      .pipe(
        switchMap((res) =>
          from(this.chatService.init(this.apiKey, userId.toString(), res.token))
        )
      )
      .subscribe((chatRes: any) => {
        this.unreadChatMessages = chatRes.me.total_unread_count;
        this.chatClient = this.chatService.chatClient;

        this.afterInitialiseChat.next(true);
      });
  }

  playNotificationSound(user: any) {
    if (this.router.url.includes('chat')) {
      return;
    }
    const otherUserMuted = !!this.chatClient.mutedUsers?.find(
      (usr) =>
        +usr.user?.id === this.currentUser.id && usr.target?.id === user.id
    );
    if (otherUserMuted) {
      return;
    }
    this.audio.currentTime = 0;
    this.audio.play().catch((error) => {
      this.playChatSoundAtNextInteraction = true;
      console.error('Audio playback failed', error);
    });
  }
}
